<template>
  <div class="mb-product-box">
    <div class="product1">
      <img :src="require('@/assets/mobile/product1.png')"/>
    </div>
    <div class="product2">
      <img :src="require('@/assets/mobile/product2.png')"/>
      <div class="desc">
        <p>星络智慧交流充电盒</p>
        <p>HD-AC7MS100</p>
        <p>智能、安全、轻巧</p>
      </div>
    </div>
    <div class="product3">
      <img :src="require('@/assets/mobile/product3.png')"/>
    </div>
    <div class="product4">
      <img :src="require('@/assets/mobile/product4.png')"/>
      <div class="desc">
        <img :src="require('@/assets/mobile/sheji.png')"/>
        <div>
          <p>匠心智造</p>
          <p>安全高效</p>
        </div>
      </div>
    </div>
    <div class="product5">
      <div class="table">
        <div class="tr">
          <div>外观尺寸</div>
          <div>500mm*210mm*111.5mm</div>
        </div>
        <div class="tr">
          <div>输入电压</div>
          <div>187～253V AC</div>
        </div>
        <div class="tr">
          <div>工作频率</div>
          <div>50Hz±1Hz</div>
        </div>
        <div class="tr">
          <div>额定电流</div>
          <div>32A</div>
        </div>
        <div class="tr">
          <div>额定功率</div>
          <div>7kW</div>
        </div>
        <div class="tr">
          <div>充电方式</div>
          <div>二维码</div>
        </div>
        <div class="tr">
          <div>充电接口</div>
          <div>充电枪（GB/T 20234.2-2015）</div>
        </div>
        <div class="tr">
          <div>枪线长度</div>
          <div>/</div>
        </div>
        <div class="tr">
          <div>显示屏</div>
          <div>5寸 触摸屏</div>
        </div>
        <div class="tr">
          <div>安装方式</div>
          <div>壁挂/立柱</div>
        </div>
        <div class="tr">
          <div>工作环境</div>
          <div>－20℃～＋60℃  相对湿度5%～95%</div>
        </div>
        <div class="tr">
          <div>储存环境</div>
          <div>－40℃～＋85℃  相对湿度10%～95%</div>
        </div>
        <div class="tr">
          <div>海拔高度</div>
          <div>≤2000米</div>
        </div>
        <div class="tr">
          <div>适用场景</div>
          <div>户内</div>
        </div>
        <div class="tr">
          <div>安全保护</div>
          <div>过压保护、欠压保护、过流保护、过温保护、板载防浪涌</div>
        </div>
        <div class="tr">
          <div>IP等级</div>
          <div>IP32</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'product'
}
</script>
<style lang="less">
.mb-product-box{
  width: 100%;
  img{
    width: 100%;
    height: 100%;
  }
  .product1{
    height: 5.58rem;
  }
  .product2{
    position: relative;
    height: 6.05rem;
    .desc{
      position: absolute;
      width: 100%;
      top: .43rem;
      left: 0;
      color: #000;
      text-align: center;
      >p{
        font-size: 12px;
        line-height: 16.5px;
        &:first-child{
          font-size: 18px;
          line-height: 25px;
        }
        &:last-child{
          color:  #13E4E8;
          margin-top: .1rem
        }
      }
    }
  }
  .product3{
    height: 7.32rem;
  }
  .product4{
    position: relative;
    height: 4.31rem;
    .desc{
      position: absolute;
      top: 0;
      left: 0;
      padding: 1.35rem 0 0 .8rem;
      color: #000;
      text-align: center;
      display: flex;
      align-items: center;
      >img{
        height: .72rem;
        width: .72rem;
      }
      >div{
        margin-left: .2rem;
        p{
          text-align: left;
          &:first-child{
            font-size: 18px;
            color: #FFF;
            line-height: 25px;
          }
          &:last-child{
            font-size: 12px;
            color: #13E4E8;
            line-height: 16.5px;
          }
        }
      }
    }
  }
  .product5{
    width: 100%;
    padding: .4rem .35rem .36rem;
    .table{
      border: 1px solid #979797;
      .tr{
        display: flex;
        align-items: center;
        &:not(:last-child) {
          border-bottom: 1px solid #979797;
        }
        >div{
          color: #333;
          font-size: 12px;
          line-height: 16.5px;
          &:nth-child(1){
            width: 1.23rem;
            text-align: center;
            padding: .13rem 0;
          }
          &:nth-child(2){
            border-left: 1px solid #979797;
            width: 5.53rem;
            text-align: left;
            padding: .13rem .27rem;
            word-break:break-all;
          }
        }
      }
    }
  }
}
</style>
